<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
    <p class="mt-3" style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
        <b>{{'PROJECT_DESCRIPTION' | translate}}.
        </b>
    </p>

    <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
        <tr>
            <th>{{'SR_NO' | translate}}</th>
            <th>{{'NAME_OF_PROJECT' | translate}}</th>
            <th>{{'PROJECT_AREA' | translate}}</th>
            <th>{{'NO_OF_COMPLETED' | translate}}</th>
            <th>{{'ACHIEVEMENT' | translate}}.</th>
            <th>{{'DISTRICT_BENEFITED'| translate}}</th>
        </tr>
        <tr>
            <th colspan=6>{{'COMPLETED_PROJECTS' | translate}}</th>
        </tr>


        <tr>
            <td>1</td>
            <td>Gurgaon Canal Command</td>
            <td>130588</td>
            <td>388</td>
            <td>67179</td>
            <td>Gurgaon</td>
        </tr>

        <tr>
            <td>2</td>
            <td>Rewari Lift Irrigation Scheme</td>
            <td>32370</td>
            <td>93</td>
            <td>17450</td>
            <td>Bhiwani</td>
        </tr>

        <tr>
            <td>3</td>
            <td>Bond Distributory Command Project/Bhiwani Area.</td>
            <td>5930</td>
            <td>26</td>
            <td>4667</td>
            <td>Bhiwani, Rohtak</td>
        </tr>

        <tr>
            <td>4</td>
            <td>Dulhera Distributory Command Project</td>
            <td>27210</td>
            <td>143</td>
            <td>27221</td>
            <td>Rohtak, Jhajjar</td>
        </tr>

        <tr>
            <td>5</td>
            <td>Hansi Area Project</td>
            <td>12140</td>
            <td>19</td>
            <td>3280</td>
            <td>Rohtak, Jhajjar</td>
        </tr>

        <tr>
            <td>
                6
            </td>
            <td>
                Jui lift Irrigation Scheme
            </td>
            <td>
                30160
            </td>

            <td>
                221
            </td>
            <td>
                27929
            </td>

            <td>
                Bhiwani
            </td>
        </tr>

        <tr>
            <td>7</td>
            <td>
                JLN Canal Command
            </td>
            <td>
                118900
            </td>
            <td>
                564
            </td>
            <td>
                93309
            </td>
            <td>
                Bhiwani, Rohtak, Jhajjar, Rewari &amp; Mohindergarh
            </td>
        </tr>

        <tr>
            <td>
                8
            </td>
            <td>
                Agra Canal Command Phase I
            </td>
            <td>
                20836
            </td>
            <td>
                244
            </td>
            <td>
                20787
            </td>
            <td>
                Faridabad
            </td>
        </tr>

        <tr>
            <td>
                9
            </td>
            <td>
                Agra Canal&nbsp;&nbsp;Command Phase-II
            </td>
            <td>
                14487
            </td>
            <td>
                54
            </td>
            <td>
                3790
            </td>
            <td>
                Faridabad
            </td>
        </tr>

        <tr>
            <td>
                10
            </td>
            <td>
                WJC Command Phase-I
            </td>
            <td>
                132000
            </td>

            <td>
                730
            </td>
            <td>
                128330
            </td>
            <td>
                Bhiwani, Rohtak, Jhajjar, Sonepat &amp; Jind.
            </td>
        </tr>

        <tr>
            <td>
                11
            </td>
            <td>
                WJC Command Phase-II
            </td>

            <td>
                51000
            </td>
            <td>
                340
            </td>

            <td>
                51000
            </td>

            <td>
                Jind and Hisar
            </td>
        </tr>

        <tr>
            <td>
                12
            </td>
            <td>
                WJC Command Phase-III
            </td>
            <td>
                36000
            </td>
            <td>
                107
            </td>
            <td>
                16621
            </td>
            <td>
                Rohtak, Sonipat and Panipat
            </td>
        </tr>

        <tr>
            <td>
                13
            </td>

            <td>
                WJC Command Phase-IV
            </td>

            <td>
                30000
            </td>

            <td>
                133
            </td>

            <td>
                26494
            </td>

            <td>
                Rohtak, Jhajjar, Sonepat, Jind, and Bhiwani

        </tr>

        <tr>
            <td>
                14
            </td>

            <td>
                WJC Command Phase-V
            </td>

            <td>
                7680
            </td>

            <td>
                54
            </td>

            <td>
                7680
            </td>

            <td>
                Jind &amp; Hisar
            </td>
        </tr>

        <tr>
            <td>
                15
            </td>

            <td>
                Bhakra Canal Command
            </td>
            <td>
                239154
            </td>
            <td>
                1148
            </td>
            <td>
                222739
            </td>
            <td>
                Ambala, Kaithal, Kurukshetra, Karnal, Jind, Hisar, Sirsa &amp; Fatehabad
            </td>
        </tr>
    </table><br>
<!-- </div> -->